import { render, staticRenderFns } from "./battery.vue?vue&type=template&id=37ac21d2&"
import script from "./battery.vue?vue&type=script&lang=js&"
export * from "./battery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ac21d2')) {
      api.createRecord('37ac21d2', component.options)
    } else {
      api.reload('37ac21d2', component.options)
    }
    module.hot.accept("./battery.vue?vue&type=template&id=37ac21d2&", function () {
      api.rerender('37ac21d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chkg/battery/battery.vue"
export default component.exports